import { Course, Interest } from "../../../../domain/entities/entities";
import { InterfaceInterestUseCases } from "../../../../domain/usecase/impl/interestUseCases";
import { ActionContext } from "vuex";
import { Order } from "../../../../domain/entities/order";
import { ListResponse } from "../../../../domain/entities/shop/product/listResponse";

class InterestState {
  interests: Interest[] = [];
  userInterests: Interest[] = [];
  trainingsInterests: Course[] = [];
  numberOfPagesTrainings = 0;
}

const state = new InterestState();

const mutations = {
  SET_INTERESTS(state: InterestState, interests: Interest[]): void {
    state.interests = interests;
  },
  SET_INTERESTS_USER(state: InterestState, interests: Interest[]): void {
    state.interests = interests;
  },
  SET_GET_USER_INTERESTS(
    state: InterestState,
    userInterests: Interest[]
  ): void {
    state.userInterests = userInterests;
  },
  SET_TRAINING_BY_INTEREST(state: InterestState, trainingsInterests: Course[]): void {
    state.trainingsInterests = trainingsInterests;
  },
  SET_NUMBER_OF_PAGES_TRAINING(state: InterestState, numberOfPagesTrainings: number) {
    state.numberOfPagesTrainings = numberOfPagesTrainings;
  }
};

const actions = {
  async loadInterests({
    commit
  }: ActionContext<InterestState, InterestState>): Promise<void> {
    const interests = await InterfaceInterestUseCases.list();
    commit("SET_INTERESTS", interests);
  },

  async listUserInterest({
    commit
  }: ActionContext<InterestState, InterestState>): Promise<void> {
    const interests = await InterfaceInterestUseCases.listUserInterest();
    commit("SET_INTERESTS_USER", interests);
  },

  async getUserInterests({
    commit
  }: ActionContext<InterestState, InterestState>): Promise<void> {
    const interests = await InterfaceInterestUseCases.getUserInterests();
    commit("SET_GET_USER_INTERESTS", interests);
  },

  async listTrainingsByInterest(
    { commit }: ActionContext<InterestState, InterestState>,
    payload: { order: Order; interestID: number }
  ): Promise<void> {
    try {
      const { order, interestID } = payload;
      const listResponse = await InterfaceInterestUseCases.listTrainingsByInterest(order, interestID);
      commit("SET_TRAINING_BY_INTEREST", listResponse.items);
      commit("SET_NUMBER_OF_PAGES_TRAINING", listResponse.page);
    } catch (e) {
      console.error(e);
      throw e;
    }
  },

  async relateInterestToUser(_, interests: Interest[]): Promise<void> {
    await InterfaceInterestUseCases.relateInterestToUser(interests);
  }
};

const getters = {
  interests: (state: InterestState): Interest[] => state.interests || [],
  userInterests: (state: InterestState): Interest[] => state.userInterests,
  trainingsInterests: (state: InterestState): Course[] => state.trainingsInterests,
  numberOfPagesTrainings: (state: InterestState): number => state.numberOfPagesTrainings,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
